import { render, staticRenderFns } from "./reattemptshipments.vue?vue&type=template&id=a47ffec0&"
import script from "./reattemptshipments.vue?vue&type=script&lang=js&"
export * from "./reattemptshipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports